<template>
  <div>
    <!--导航栏 start-->
    <van-search
      v-model="mobile"
      show-action
      placeholder="请输入手机号"
      @search="onSearch"
      @cancel="onCancel"
    />
    <!--导航栏 end-->
    <!-- 列表 start-->
    <van-grid :column-num="4" :border="false">
      <van-grid-item text="订单编号" />
      <van-grid-item text="充值金额" />
      <van-grid-item text="赠送金额" />
      <van-grid-item text="手机号" />
      <!-- <van-grid-item text="操作" /> -->
    </van-grid>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
      <van-cell v-for="item in list" :key="item.id">
        <van-grid :column-num="4" :border="false">
          <van-grid-item :text="item.order_no" />
          <van-grid-item :text="'￥'+item.money" />
          <van-grid-item :text="item.extra_money"></van-grid-item>
          <van-grid-item :text="item.tel" />
        </van-grid>
      </van-cell>
    </van-list>
    <!-- 列表 end-->
  </div>
</template>

<script>
import Vue from "vue";
import { List, Grid, GridItem, Search } from "vant";
// import VueCookie from "vue-cookies";

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(List);

export default {
  name: "Order",
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      loading: false,
      finished: false,
      //手机号
      mobile: "",
    };
  },
  methods: {
    onSearch(v) {
      this.order_no = v;
      this.page = 1;
      this.list = [];
      this.getList();
    },
    onCancel() {
      this.order_no = "";
      this.page = 1;
      this.list = [];
      this.getList();
    },
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/StoreHomepage");
    },
    getList() {
      var that = this;
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http
        .post("/wechat/api.order/chargeList", {
          pageNum: this.page,
          pageSize: this.limit,
          mobile: this.mobile,
        })
        .then((response) => {
          // 加载状态结束
          that.loading = false;
          // console.log(response.data.data)
          that.list = that.list.concat(response.data.rows);
          // 页码
          that.page++;
          // this.finished = true;
          if (response.data.rows.length < that.limit) {
            that.finished = true;
          }
        });
    },
    order_detail(id) {
      // this.$router.push("/SalesmanUpdate/"+id);
      this.$router.push({ path: "/OrderDetails", query: { id: id } });
      // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
    },
  },
};
</script>

<style scoped>
.search option {
  padding: 0.5rem;
  color: red;
  font-size: 0.5rem;
}
</style>
